import React from 'react'
import './core.scss';
const Core = () => {
    return (
      <section className='Core_main' id='solution'>
            <div className='innner_power'>
                <img src='\assets\shade.png' className='shade_img' />
                <div className='custom-container'>
                    <div className='nnermore'>

                        <div>
                            <img src='\assets\coinanother.png' className='img-fluid' />
                        </div>
                         <div>
                            <button>
                                <img src='\assets\solution.svg'  />
                                Solution
                            </button>
                            <h2>Invest in the Core Infrastructure of Crypto</h2>
                            <ul class="my-list">
                                <li>Buy-back & burn programs reducing supply.</li>
                                <li>Utility-driven demand (discounts, governance, launchpad access).</li>
                                         <li>Direct exposure to platform growth.</li>
                            </ul>
                        </div>

                    </div>

                </div>
            </div>

        </section>
    )
}

export default Core
